/*@flow*/
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useState } from 'react';
import Layout from './Layout';
import sections from './Nav/config';
import Cell from './Cell';
import CellHeader from './Cell/Header';
import CellBody from './Cell/Body';
import ScrollToTop from 'comps/App/ScrollTo/Top';
import scrollToAnchor from 'lib/scrollToAnchor';
import { ChartDeckContext } from './contexts';

const removeNewDecks = (decks, newDecks) => {
  const newDeckIds = newDecks.map(v => v.id).sort();
  return decks.filter(v => !newDeckIds.includes(v.id));
};

const Component = () => {
  const [decks, setChartDecks] = useState([]);

  return (
    <ChartDeckContext.Provider
      value={{
        addMapTiles: newDecks => {
          let woNewDecks = removeNewDecks(decks, newDecks);
          // Clean up the palate of the map.
          setChartDecks(woNewDecks);
          // Add the new decks
          const decksWithMapDecks = woNewDecks.concat(newDecks);
          // Add the decks to map
          setChartDecks(decksWithMapDecks);
        },
        removeMapTiles: newDecks => {
          let woNewDecks = removeNewDecks(decks, newDecks);
          // Add the decks without new decks
          setChartDecks(woNewDecks);
        },
      }}
    >
      <Layout decks={decks}>
        {sections.map((section, i) => {
          return (
            <Cell col={5} row={3} key={i}>
              <CellHeader title={section.name} />
              <CellBody innerStyles={'padding: 0;'}>
                {section.component &&
                  section.component({
                    charts: section.charts,
                    name: section.name,
                  })}
              </CellBody>
            </Cell>
          );
        })}

        <ScrollToTop andThen={scrollToAnchor} />
      </Layout>
    </ChartDeckContext.Provider>
  );
};

export default Component;
